/**
 * @flow
 * @relayHash 1abeaf96e893e326279f44ffc4369b75
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type srcAboutPageQueryVariables = {||};
export type srcAboutPageQueryResponse = {|
  +about: ?{|
    +banner: ?string,
    +story: ?$ReadOnlyArray<?{|
      +type: ?string,
      +section: ?{|
        +title: ?string,
        +paragraph: ?{|
          +content: ?$ReadOnlyArray<?{|
            +type: ?string,
            +text: ?string,
            +spans: ?$ReadOnlyArray<{|
              +start: number,
              +end: number,
              +type: string,
              +data: ?{|
                +id: ?string,
                +uid: ?string,
                +url: ?string,
                +type: ?string,
                +slug: ?string,
                +link_type: ?string,
              |},
            |}>,
            +label: ?string,
          |}>
        |},
        +picture: ?string,
      |},
      +inlinePicture: ?{|
        +picture: ?string,
        +caption: ?string,
      |},
      +pictureDuo: ?$ReadOnlyArray<?{|
        +picture: ?string,
        +caption: ?string,
      |}>,
    |}>,
    +team: ?$ReadOnlyArray<?{|
      +type: ?string,
      +teamMember: ?{|
        +portrait: ?string,
        +name: ?string,
        +occupation: ?string,
        +location: ?string,
        +description: ?string,
        +facebook: ?string,
        +twitter: ?string,
        +instagram: ?string,
        +linkedin: ?string,
        +website: ?string,
      |},
      +paragraph: ?{|
        +content: ?$ReadOnlyArray<?{|
          +type: ?string,
          +text: ?string,
          +spans: ?$ReadOnlyArray<{|
            +start: number,
            +end: number,
            +type: string,
            +data: ?{|
              +id: ?string,
              +uid: ?string,
              +url: ?string,
              +type: ?string,
              +slug: ?string,
              +link_type: ?string,
            |},
          |}>,
        |}>
      |},
    |}>,
    +contact: ?$ReadOnlyArray<?{|
      +type: ?string,
      +contactBox: ?{|
        +title: ?string,
        +description: ?string,
        +email: ?string,
        +phone: ?string,
        +link: ?string,
      |},
      +visit: ?{|
        +place_name: ?string,
        +address: ?string,
        +email: ?string,
        +phone: ?string,
        +working_hours: ?string,
        +map: ?{|
          +latitude: ?number,
          +longitude: ?number,
        |},
      |},
    |}>,
    +seo: ?{|
      +title: ?string,
      +description: ?string,
    |},
    +social: ?{|
      +generic: ?$ReadOnlyArray<?{|
        +title: ?string,
        +description: ?string,
        +image: ?string,
      |}>,
      +twitter: ?$ReadOnlyArray<?{|
        +type: ?string,
        +title: ?string,
        +description: ?string,
        +handle: ?string,
        +image: ?string,
      |}>,
    |},
  |}
|};
export type srcAboutPageQuery = {|
  variables: srcAboutPageQueryVariables,
  response: srcAboutPageQueryResponse,
|};
*/


/*
query srcAboutPageQuery {
  about {
    banner
    story {
      type
      section {
        title
        paragraph {
          content {
            type
            text
            spans {
              start
              end
              type
              data {
                id
                uid
                url
                type
                slug
                link_type
              }
            }
            label
          }
        }
        picture
      }
      inlinePicture {
        picture
        caption
      }
      pictureDuo {
        picture
        caption
      }
    }
    team {
      type
      teamMember {
        portrait
        name
        occupation
        location
        description
        facebook
        twitter
        instagram
        linkedin
        website
      }
      paragraph {
        content {
          type
          text
          spans {
            start
            end
            type
            data {
              id
              uid
              url
              type
              slug
              link_type
            }
          }
        }
      }
    }
    contact {
      type
      contactBox {
        title
        description
        email
        phone
        link
      }
      visit {
        place_name
        address
        email
        phone
        working_hours
        map {
          latitude
          longitude
        }
      }
    }
    seo {
      title
      description
    }
    social {
      generic {
        title
        description
        image
      }
      twitter {
        type
        title
        description
        handle
        image
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "text",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "spans",
  "storageKey": null,
  "args": null,
  "concreteType": "ArticleTextSpan",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "start",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "end",
      "args": null,
      "storageKey": null
    },
    v0,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "data",
      "storageKey": null,
      "args": null,
      "concreteType": "ArticleTextSpanData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "uid",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url",
          "args": null,
          "storageKey": null
        },
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "slug",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "link_type",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v5 = [
  v4,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "caption",
    "args": null,
    "storageKey": null
  }
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v10 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "about",
    "storageKey": null,
    "args": null,
    "concreteType": "About",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "banner",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "story",
        "storageKey": null,
        "args": null,
        "concreteType": "StorySlices",
        "plural": true,
        "selections": [
          v0,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "section",
            "storageKey": null,
            "args": null,
            "concreteType": "StorySection",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "paragraph",
                "storageKey": null,
                "args": null,
                "concreteType": "StoryParagraph",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ArticleText",
                    "plural": true,
                    "selections": [
                      v0,
                      v2,
                      v3,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "label",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              v4
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "inlinePicture",
            "storageKey": null,
            "args": null,
            "concreteType": "ArticleInlinePicture",
            "plural": false,
            "selections": v5
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pictureDuo",
            "storageKey": null,
            "args": null,
            "concreteType": "ArticleInlinePicture",
            "plural": true,
            "selections": v5
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "team",
        "storageKey": null,
        "args": null,
        "concreteType": "TeamSlices",
        "plural": true,
        "selections": [
          v0,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "teamMember",
            "storageKey": null,
            "args": null,
            "concreteType": "TeamMember",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "portrait",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "occupation",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "location",
                "args": null,
                "storageKey": null
              },
              v6,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "facebook",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "twitter",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "instagram",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "linkedin",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "website",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "paragraph",
            "storageKey": null,
            "args": null,
            "concreteType": "TeamParagraph",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "content",
                "storageKey": null,
                "args": null,
                "concreteType": "ArticleText",
                "plural": true,
                "selections": [
                  v0,
                  v2,
                  v3
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contact",
        "storageKey": null,
        "args": null,
        "concreteType": "ContactSlices",
        "plural": true,
        "selections": [
          v0,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contactBox",
            "storageKey": null,
            "args": null,
            "concreteType": "ContactBoxes",
            "plural": false,
            "selections": [
              v1,
              v6,
              v7,
              v8,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "link",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "visit",
            "storageKey": null,
            "args": null,
            "concreteType": "ContactVisit",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "place_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "address",
                "args": null,
                "storageKey": null
              },
              v7,
              v8,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "working_hours",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "map",
                "storageKey": null,
                "args": null,
                "concreteType": "GeoPoint",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "latitude",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "longitude",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "seo",
        "storageKey": null,
        "args": null,
        "concreteType": "SEO",
        "plural": false,
        "selections": [
          v1,
          v6
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "social",
        "storageKey": null,
        "args": null,
        "concreteType": "SocialMedia",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "generic",
            "storageKey": null,
            "args": null,
            "concreteType": "GenSocialSlices",
            "plural": true,
            "selections": [
              v1,
              v6,
              v9
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "twitter",
            "storageKey": null,
            "args": null,
            "concreteType": "TwtrSlices",
            "plural": true,
            "selections": [
              v0,
              v1,
              v6,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "handle",
                "args": null,
                "storageKey": null
              },
              v9
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcAboutPageQuery",
  "id": null,
  "text": "query srcAboutPageQuery {\n  about {\n    banner\n    story {\n      type\n      section {\n        title\n        paragraph {\n          content {\n            type\n            text\n            spans {\n              start\n              end\n              type\n              data {\n                id\n                uid\n                url\n                type\n                slug\n                link_type\n              }\n            }\n            label\n          }\n        }\n        picture\n      }\n      inlinePicture {\n        picture\n        caption\n      }\n      pictureDuo {\n        picture\n        caption\n      }\n    }\n    team {\n      type\n      teamMember {\n        portrait\n        name\n        occupation\n        location\n        description\n        facebook\n        twitter\n        instagram\n        linkedin\n        website\n      }\n      paragraph {\n        content {\n          type\n          text\n          spans {\n            start\n            end\n            type\n            data {\n              id\n              uid\n              url\n              type\n              slug\n              link_type\n            }\n          }\n        }\n      }\n    }\n    contact {\n      type\n      contactBox {\n        title\n        description\n        email\n        phone\n        link\n      }\n      visit {\n        place_name\n        address\n        email\n        phone\n        working_hours\n        map {\n          latitude\n          longitude\n        }\n      }\n    }\n    seo {\n      title\n      description\n    }\n    social {\n      generic {\n        title\n        description\n        image\n      }\n      twitter {\n        type\n        title\n        description\n        handle\n        image\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcAboutPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v10
  },
  "operation": {
    "kind": "Operation",
    "name": "srcAboutPageQuery",
    "argumentDefinitions": [],
    "selections": v10
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fdc5d2da7426acec3bf2ccdd7dd191cc';
module.exports = node;
